import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { DptmasterService } from 'src/app/services/dptmaster.service';
import { DeviceService } from 'src/app/services/device.service';
import { DivisionService } from 'src/app/services/division.service';
import { AlertService } from 'src/app/services/alert.service';
import { InputformatService } from 'src/app/services/inputformat.service';
@Component({
  selector: 'app-dbt-product-specassign',
  templateUrl: './dbt-product-specassign.component.html',
  styleUrls: ['./dbt-product-specassign.component.scss']
})

export class DbtProductSpecassignComponent implements OnInit {
  @Input() actionId: any;
  @Input() resultdata: any;
  @Output() backComp = new EventEmitter<any>();
  valuesForm!: FormGroup;
  value: any;
  compVal: any[] = [];
  selectedValue: any[];
  id: any;
  GetByIdResponse: any;
  filtercompVal: any[];

  constructor
    (
      private fb: FormBuilder,
      private location: Location,
      private dptmasterservice: DptmasterService,
      private divisionService: DivisionService,
      private alertService: AlertService,
      private inputFormatService : InputformatService


    ) { }

  ngOnInit(): void {
    this.id = this.resultdata.id ? this.resultdata.id : 0
    this.initializeForm();
    if (this.id) {
      this.getSchemeLookyp(this.id);
    }

  }

  initializeForm() {
    this.valuesForm = this.fb.group({
      name: new FormControl('', Validators.required),
      Description: new FormControl('', Validators.required),
    });
  }
  getSchemeLookyp(id: number) {
    this.dptmasterservice.getDBTproductspecbyId(id).subscribe((res) => {
      this.GetByIdResponse = res

      if (this.GetByIdResponse) {
        this.valuesForm.patchValue({
          name: res.name,
          Description: res.description,
        });
      }
    })
  }

  back() {
    const msg = { show: true };
    this.backComp.emit(msg);
  }

  Update() {
    if (this.valuesForm.valid) {

      let data = {
        "id": this.id,
        "name": this.valuesForm.value.name,
        "description": this.valuesForm.value.Description
      }
      this.dptmasterservice.UpdateDBTproductspec(data).subscribe((res) => {
        if (res.isSuccess) {
          this.alertService.success(this.actionId==0 ? 'Product Specification Saved Successfully':this.actionId==1 ? 'Product Specification Updated Successfully':'');
          this.back()
        }
      })
    }
    else{
      this.valuesForm.markAllAsTouched();
    }
  }
 
  onInput(event: any, regexPattern: any): void {
    this.inputFormatService.isNumericOrHyphenOrSpace(event, regexPattern);
  }

}